import React, { useContext, useEffect, useMemo, useState } from "react"
import {
  Form,
  FormGroup,
  label,
  Input,
  Button,
  Row,
  Col,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Badge,
  Card,
  CardBody,
  CardText,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap"
import { FaSync } from "react-icons/fa"
import { FiRefreshCw } from "react-icons/fi"

import apiHandler from "../../common/config/apiHandler"
import { DataContext } from "../../context/dataContext"
import BookingActions from "./bookingActions"
import BookingDetails from "./bookingDetails"
import AmendBookingModal from "./amendBooking"
import IncompleteBookingForm from "./incompleteBooking"
import toast from "react-hot-toast"
import { useNavigate } from "react-router-dom"
import AmendDates from "./amendDates"
import { Elements } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js"
import EditCustomerTravelDetails from "./CustomerAndVehicle"
import TransferBookingModal from "./shiftBooking"
import CancelBookingModal from "./cancelBooking"
import CustomLoader from "../../components/Loader/loader"
import EmailModal from "./emailModal"
import SeeNotes from "./seeNotes"
import EmailEventsSection from "./emailEvents"
import Loader from "../../components/Loader/loader"
import DatePicker from "react-datepicker"
import { HiXCircle } from "react-icons/hi"
import { IoIosCheckmarkCircle } from "react-icons/io"

import "react-datepicker/dist/react-datepicker.css"
import {
  getInCompleteBooking,
  getCancelBooking,
  getNotes,
  initiateSocketConnection,
  sendIncompleteToCompleteAlert,
  getIncompleteToCompleteAlert,
} from "../../common/config/socket.service"
import moment, { duration } from "moment-timezone"
import CreateNotes from "./Createnote"

const AllBookings = () => {
  const {
    token,
    public_key,
    bookings,
    setBookings,
    bookingDetails,
    bookingHistory,
    setBookingHistory,
    handleFetchBookingDetails,
    fetchAirports,
    fetchCompanies,
    fetchSites,
    sites,
    airports,
    companies,
    fetchSubscribeKey,
    subscribeKey,
  } = useContext(DataContext)

  const formatDate = date => {
    const d = new Date(date)
    const year = d.getFullYear()
    const month = String(d.getMonth() + 1).padStart(2, "0")
    const day = String(d.getDate()).padStart(2, "0")
    return `${year}-${month}-${day}`
  }

  const now = new Date()
  const threeDaysBeforeNow = new Date(now)
  threeDaysBeforeNow.setDate(now.getDate() - 1)

  const [filters, setFilters] = useState({
    keyword: "",
    keyword_type: "",
    site_id: "",
    airport_id: "",
    company_id: "",
    type: "",
    status: "",
    from_date: "",
    to_date: "",
  })

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isBookingHistoryModalOpen, setIsBookingHistoryModalOpen] =
    useState(false)
  const [isEditModalOpen, setIsEditModalOpen] = useState(false)
  const [editData, setEditData] = useState({})
  const [isExtendModalOpen, setIsExtendModalOpen] = useState(false)
  const [extendData, setExtendData] = useState({})

  const [isShiftModalOpen, setIsShiftModalOpen] = useState(false)
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false)
  const [cancelData, setCancelData] = useState({
    refundAmount: "",
    specialNotes: "",
  })

  const [reActiveModalOpen, setReActiveModalOpen] = useState(false)
  const [reActiveData, setReActiveData] = useState({
    transactionId: "",
    specialNotes: "",
  })

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [deleteData, setDeleteData] = useState(null)
  const [filteredBookings, setFilteredBookings] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const [currentPage, setCurrentPage] = useState(1)
  const [isSearchActive, setIsSearchActive] = useState(false)

  const [totalPages, setTotalPages] = useState(1)
  const [totalBookings, setTotalBookings] = useState(0)

  const [bookingPerPage, setBookingsPerPage] = useState(50)

  const [selectedBookings, setSelectedBookings] = useState([])
  const [toastShown, setToastShown] = useState(false)
  const [incompleteUser, setIncompleteUser] = useState("")

  const [combinedData, setCombinedData] = useState({
    site_id: String(bookingDetails?.site_id),
    reference_no: bookingDetails?.reference_no,
    title: "",
    first_name: "",
    last_name: "",
    email: "",
    contact_no: "",
    make: "",
    model: "",
    color: "",
    reg_no: "",
    departure_time: "",
    arrival_time: "",
    departure_terminal: "",
    departure_flight_no: "",
    arrival_terminal: "",
    arrival_flight_no: "",
    no_of_peoples: "",
    company_email: true,
    customer_email: true,
  })
  const [editLoader, setEditLoader] = useState(false)

  const [userId, setUserId] = useState(null)

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"))
    if (user && user.id) {
      setUserId(user.id)
    }
  }, [])

  const handleCombinedChange = e => {
    const { name, type, value } = e.target
    setCombinedData(prevData => ({
      ...prevData,
      [name]:
        type === "checkbox" ? (prevData[name] === "1" ? "0" : "1") : value,
    }))
  }

  const handleCombinedSubmit = async e => {
    e.preventDefault()
    setEditLoader(true)
    try {
      const customerVehicleTravelResponse = await apiHandler({
        endpoint2: "/crsbookings/editBooking",
        method: "POST",
        data: combinedData,
        options: {
          "Content-Type": "application/json",
        },
      })

      if (customerVehicleTravelResponse.response_code === 200) {
        setEditLoader(false)
        toast.success(customerVehicleTravelResponse?.data)
      } else {
        setEditLoader(true)
      }
    } catch (error) {
      console.error("Error updating details:", error)
    }
  }

  const [amendBookingModal, setAmendBookingModal] = useState(false)

  const toggleAmendBookingModal = () => setAmendBookingModal(!amendBookingModal)

  const [activeButton, setActiveButton] = useState("")

  const [isDeleting, setIsDeleting] = useState(false)

  const [activeTab, setActiveTab] = useState("emailEvents")

  const [incompleteModalOpen, setIncompleteModalOpen] = useState(false)

  const [isAmendDatesModalOpen, setIsAmendDatesModalOpen] = useState(false)
  const [selectedBooking, setSelectedBooking] = useState([])
  const [socketObj, setSocketObj] = useState({})
  const [countdowns, setCountdowns] = useState({})

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768)
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const getColStyle = defaultWidth => ({
    width: isMobile ? "100%" : defaultWidth,
    marginBottom: isMobile ? "10px" : "0",
  })

  const toggleAmendDatesModal = () =>
    setIsAmendDatesModalOpen(!isAmendDatesModalOpen)

  const handleAmendDatesSubmit = amendData => {}

  const navigate = useNavigate()

  const toggleTab = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab)
    }
  }

  const renderTable = () => {
    const tableStyle = {
      tableLayout: "fixed", // Ensures the table cells have equal width
      wordWrap: "break-word", // Prevents text overflow by wrapping text within cells
    }

    return (
      <Table striped bordered hover responsive style={tableStyle}>
        <tbody>
          {activeTab === "emailEvents" && (
            // emailEventsData.map((event, index) => (
            //   <tr key={index}>
            //     <td>{event.event}</td>
            //     <td>{event.Recipient}</td>
            //     <td>{event.date}</td>
            //   </tr>

            // ))
            <EmailEventsSection />
          )}

          {activeTab === "procedure" && (
            // <p>{removeHtmlTags(bookingDetails?.bookingDetails[0]?.company?.terms_conditions)}</p>

            <div
              style={{
                height: "400px",
                overflowY: "auto",
                border: "1px solid #ddd",
                borderRadius: "4px",
                padding: "0px 20px",
              }}
              dangerouslySetInnerHTML={{
                __html:
                  bookingDetails?.bookingDetails[0]?.company?.terms_conditions,
              }}
            />
          )}
        </tbody>
      </Table>
    )
  }

  useEffect(() => {
    fetchSites()
    fetchCompanies()
    fetchAirports()
  }, [])

  const formatTime = seconds => {
    const m = Math.floor((seconds % 3600) / 60)
    const s = seconds % 60
    return `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`
  }

  const fetchBookingsBySearch = async (page = 1, limit = bookingPerPage) => {
    setLoading(true)
    setIsSearchActive(true)
    try {
      const queryString = Object.entries(filters)
        .filter(([key, value]) => value !== undefined && value !== "")
        .map(([key, value]) => {
          if (key == "status") {
            return `${key}=${encodeURIComponent(
              value == "completed"
                ? "completed"
                : value == "incompleted"
                ? "incompleted"
                : value
            )}`
          } else {
            return `${key}=${encodeURIComponent(value)}`
          }
        })
        .join("&")

      const response = await apiHandler({
        endpoint: `/backend/bookings?limit=${bookingPerPage}&page=${page}${
          queryString ? `&${queryString}` : ""
        }`,
        method: "GET",
        options: {
          "x-access-token": token || localStorage.getItem("token"),
        },
      })

      if (response.code === 200) {
        setLoading(false)
        const totalPages = Math.ceil(response.data.totalRecords / limit)
        setBookings(response?.data?.rows)
        setFilteredBookings(response?.data?.rows)
        setTotalBookings(response?.data?.totalRecords)
        setTotalPages(totalPages > 0 ? totalPages : 1)
      } else {
        setLoading(false)
        setError(response.message)
      }
    } catch (err) {
      toast.error("Token Expired.. Redirecting to Login Page.....")
      setTimeout(() => {
        navigate("/login")
      }, 2000)
      setError(err)
    } finally {
      setLoading(false)
    }
  }

  const fetchBookings = async (page = 1, limit = bookingPerPage, date) => {
    setLoading(true)
    try {
      const response = await apiHandler({
        endpoint: `/backend/bookings?limit=${bookingPerPage}&page=${page}&from_date=${formatDate(
          date ? date : threeDaysBeforeNow
        )}&to_date=${formatDate(date ? date : now)}`,
        method: "GET",
        options: {
          "x-access-token": token || localStorage.getItem("token"),
        },
      })

      if (response.code == 200) {
        setLoading(false)
        const totalPages = Math.ceil(response.data.totalRecords / limit)
        setBookings(response?.data?.rows)
        setFilteredBookings(response?.data?.rows)
        setTotalBookings(response?.data?.totalRecords)
        setTotalPages(totalPages > 0 ? totalPages : 1)
      } else {
        setLoading(false)
        setError(response.message)
      }
    } catch (err) {
      setError(err)

      toast.error("Token Expired.. Redirecting to Login Page.....")
      setTimeout(() => {
        navigate("/login")
      }, 2000)
    } finally {
      setLoading(false)
    }
  }

  const fetchBookingsByRefresh = async (page = 1, limit = bookingPerPage) => {
    const now = new Date()
    const oneDayBeforeNow = new Date()
    oneDayBeforeNow.setDate(now.getDate() - 1)
    setLoading(true)
    try {
      const response = await apiHandler({
        endpoint: `/backend/bookings?limit=${limit}&page=${page}&from_date=${formatDate(
          oneDayBeforeNow
        )}&to_date=${formatDate(now)}`,
        method: "GET",
        options: {
          "x-access-token": token || localStorage.getItem("token"),
        },
      })

      if (response.code === 200) {
        setLoading(false)
        const totalPages = Math.ceil(response.data.totalRecords / limit)
        setBookings(response?.data?.rows)
        setFilteredBookings(response?.data?.rows)
        setTotalBookings(response?.data?.totalRecords)
        setTotalPages(totalPages > 0 ? totalPages : 1)
      } else {
        setLoading(false)
        setError(response.message)
      }
    } catch (err) {
      setError(err)
      toast.error("Token Expired.. Redirecting to Login Page.....")
      setTimeout(() => {
        navigate("/login")
      }, 2000)
    } finally {
      setLoading(false)
    }
  }

  useMemo(() => {
    if (isSearchActive) {
      fetchBookingsBySearch(currentPage, bookingPerPage)
    } else {
      fetchBookings(currentPage, bookingPerPage)
    }
  }, [currentPage, isSearchActive, bookingPerPage])

  useMemo(() => {
    initiateSocketConnection()

    getInCompleteBooking((err, data, status) => {
      if (data?.data) {
        setSocketObj(data?.data)
      }
    })
    getCancelBooking((err, data, status) => {
      if (data?.data) {
        setSocketObj(data?.data)
      }
    })
    getNotes((err, data, status) => {
      if (data?.data) {
        setSocketObj(data?.data)
      }
    })
    getIncompleteToCompleteAlert((err, data, status) => {
      if (data) {
        let findSingleBooking = bookings?.find(
          booking => booking?.reference_no == data?.reference_no
        )
        if (toastShown == false) {
          const loggedInUser = JSON.parse(localStorage.getItem("user"))

          if (loggedInUser?.name !== data?.name) {
            toast.success(
              `${data.name} is working on this booking ${data.reference_no}. Please try after some time`,
              { duration: 3000 }
            )
          }
          setToastShown(true)
        }
        if (findSingleBooking) {
          let duplicate = bookings?.map(book => {
            return book?.id == findSingleBooking?.id
              ? { ...findSingleBooking, status: data?.name }
              : book
          })
          setBookings(duplicate)
        }
      }
    })
  }, [toastShown])

  useMemo(() => {
    if (Object.keys(socketObj)?.length > 0) {
      let findSingleBooking = bookings?.find(
        booking => booking?.id == socketObj?.id
      )
      if (findSingleBooking) {
        if (socketObj?.bookingDetails[0]?.status == "completed") {
          toast.success(
            socketObj?.bookingDetails[0]?.booking_type == "backend"
              ? `${socketObj?.bookingDetails[0]?.user?.first_name} complete this booking ${findSingleBooking?.reference_no}`
              : `Incoming update booking reference is : ${findSingleBooking?.reference_no}`
          )
        }
        if (socketObj?.bookingDetails[0]?.status == "cancelled") {
          toast.success(
            `Cancelled update booking reference is : ${findSingleBooking?.reference_no}`
          )
        }
        let duplicate = bookings?.map(book => {
          return book?.id == findSingleBooking?.id ? { ...socketObj } : book
        })
        setBookings(duplicate)
      } else {
        toast.success(
          socketObj?.bookingDetails[0]?.booking_type == "backend"
            ? `${socketObj?.bookingDetails[0]?.user?.first_name} create this booking ${socketObj?.reference_no}`
            : `New booking reference is : ${socketObj?.reference_no}`
        )
        let duplicate = [socketObj, ...bookings]
        setBookings(duplicate)
      }
    }
  }, [socketObj])

  // Start of Timmer
  useEffect(() => {
    const newCountdowns = {}

    bookings.forEach(booking => {
      if (booking?.createdAt) {
        // Ensure createdAt exists
        const createdAtUK = moment(booking.createdAt)
          .tz("Europe/London")
          .valueOf() // Get timestamp (milliseconds)

        const countdownEndTime = createdAtUK + 5 * 60 * 1000 // Add 10 minutes
        newCountdowns[booking.id] = countdownEndTime
      }
    })

    console.log(newCountdowns, "newCountdowns")

    setCountdowns(newCountdowns)
  }, [bookings])

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdowns(prevCountdowns => {
        const nowUK = moment().tz("Europe/London").valueOf() // Current UK timestamp
        const updatedCountdowns = {}

        Object.keys(prevCountdowns).forEach(bookingId => {
          const timeLeft = prevCountdowns[bookingId] - nowUK
          console.log("timeLeft", timeLeft)
          if (timeLeft > 0) {
            updatedCountdowns[bookingId] = prevCountdowns[bookingId]
          }
        })

        return updatedCountdowns
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  // END FOR REAL TIME BOOKING

  const refreshBookings = () => {
    setFilters({
      keyword: "",
      keyword_type: "",
      site_id: "",
      airport_id: "",
      company_id: "",
      type: "",
      status: "",
      from_date: "",
      to_date: "",
    })

    fetchBookingsByRefresh(1, 50)
    handlePageChange(1)
    setBookingsPerPage(50)
  }

  const handleSearch = () => {
    setIsSearchActive(true)
    setCurrentPage(1)
    fetchBookingsBySearch(1, bookingPerPage)
  }

  const handlePageChange = pageNumber => {
    setCurrentPage(pageNumber)
  }

  const handleInputChange = e => {
    const { name, value } = e.target
    setFilters(prevFilters => ({
      ...prevFilters,
      [name]: value,
    }))
  }

  useMemo(() => {
    getIncompleteToCompleteAlert((err, data, status) => {
      if (data) {
        setIncompleteUser(data)
      }
    })
  }, [])

  const handleSelectAll = () => {
    if (selectedBookings.length === bookings.length) {
      // If all are selected, clear the selection
      setSelectedBookings([])
    } else {
      // If not all are selected, select all
      setSelectedBookings(bookings.map(booking => booking.id))
    }
  }

  const renderPagination = () => {
    const maxPagesToShow = 3
    const pageLinks = []

    const startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2))
    const endPage = Math.min(totalPages, startPage + maxPagesToShow - 1)

    if (startPage > 1) {
      pageLinks.push(
        <PaginationItem key={1}>
          <PaginationLink onClick={() => handlePageChange(1)}>1</PaginationLink>
        </PaginationItem>
      )

      if (startPage > 2) {
        pageLinks.push(
          <PaginationItem disabled key="start-ellipsis">
            <PaginationLink>...</PaginationLink>
          </PaginationItem>
        )
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pageLinks.push(
        <PaginationItem active={i === currentPage} key={i}>
          <PaginationLink onClick={() => handlePageChange(i)}>
            {i}
          </PaginationLink>
        </PaginationItem>
      )
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pageLinks.push(
          <PaginationItem disabled key="end-ellipsis">
            <PaginationLink>...</PaginationLink>
          </PaginationItem>
        )
      }
      pageLinks.push(
        <PaginationItem key={totalPages}>
          <PaginationLink onClick={() => handlePageChange(totalPages)}>
            {totalPages}
          </PaginationLink>
        </PaginationItem>
      )
    }

    return (
      <Pagination
        aria-label="Page navigation example"
        className="d-flex justify-content-center border-secondary"
      >
        <PaginationItem disabled={currentPage === 1}>
          <PaginationLink
            previous
            onClick={() => handlePageChange(currentPage - 1)}
          />
        </PaginationItem>
        {pageLinks}
        <PaginationItem disabled={currentPage === totalPages}>
          <PaginationLink
            next
            onClick={() => handlePageChange(currentPage + 1)}
          />
        </PaginationItem>
      </Pagination>
    )
  }

  const handleFetchBookingHistory = async bookingID => {
    toggleBookingHistoryModal(true)

    try {
      const response = await apiHandler({
        endpoint: `/backend/bookings/bookingDetails/${bookingID}`,
        method: "GET",
        options: {
          "x-access-token": token || localStorage.getItem("token"),
        },
      })
      setBookingHistory(response?.data)
    } catch (err) {
      toast.error("Token Expired.. Redirecting to Login Page.....")
      setTimeout(() => {
        navigate("/login")
      }, 2000)
      setError(err)
    } finally {
      setLoading(false)
    }
  }

  if (error) return <div>Error fetching bookings: {error.message}</div>

  const handleDeleteClick = booking => {
    setDeleteData(booking)
    setIsDeleteModalOpen(true)
    setSelectedBooking(booking?.id)

    fetchSubscribeKey(
      booking?.bookingDetails[0]?.company?.sku_tag,
      booking?.site_id
    )
  }

  // const handleDelete = async () => {
  //   if (!deleteData) return;

  //   try {
  //     await apiHandler({
  //       endpoint2: "/crsbookings/delete",
  //       method: "POST",
  //       data: {
  //         key: subscribeKey,
  //         booking_id: selectedBooking,
  //         user_id: String(deleteData?.bookingDetails?.[0]?.user_id),
  //       },
  //       options: {
  //         "x-access-token": token || localStorage.getItem("token"),
  //       },
  //     });

  //     // refreshBookings();
  //     // setIsDeleteModalOpen(false);
  //     setDeleteData(null);
  //   } catch (err) {
  //     setError(err.message);
  //   }
  // };

  const handleDelete = async () => {
    if (!subscribeKey) return

    setIsDeleting(true)

    try {
      const bookingIds = Array.isArray(selectedBooking)
        ? selectedBooking
        : [selectedBooking]

      const deleteResponse = await apiHandler({
        endpoint2: "/crsbookings/delete",
        method: "POST",
        data: {
          key: subscribeKey,
          booking_id: JSON.stringify(bookingIds),
          user_id: String(deleteData?.bookingDetails?.[0]?.user_id),
        },
        options: {
          "x-access-token": token || localStorage.getItem("token"),
        },
      })

      if (deleteResponse?.response_code == 200) {
        setIsDeleteModalOpen(false)
        refreshBookings()
        setIsDeleting(false)
      } else {
        setIsDeleteModalOpen(false)
        toast.error(deleteResponse?.response_message)
        setIsDeleting(false)
      }
      setDeleteData(null)
    } catch (err) {
      setIsDeleting(false)
      setIsDeleteModalOpen(false)
      setError(err.message)
    } finally {
      setIsDeleting(false)
    }
  }

  const toggleReactiveModal = () => setReActiveModalOpen(!reActiveModalOpen)

  const toggleCancelModal = () => setIsCancelModalOpen(!isCancelModalOpen)

  const toggleShiftModal = () => setIsShiftModalOpen(!isShiftModalOpen)

  const toggleBookingHistoryModal = () =>
    setIsBookingHistoryModalOpen(!isBookingHistoryModalOpen)

  const toggleModal = () => setIsModalOpen(!isModalOpen)
  const toggleEditModal = () => setIsEditModalOpen(!isEditModalOpen)

  const handleEditClick = async booking => {
    try {
      const response = await apiHandler({
        endpoint: `/backend/bookings/bookingDetails/${booking.id}`,
        method: "GET",
        options: {
          "x-access-token": token || localStorage.getItem("token"),
        },
      })

      setEditData(response?.data)
      toggleEditModal()
    } catch (err) {
      toast.error("Token Expired.. Redirecting to Login Page.....")
      setTimeout(() => {
        navigate("/login")
      }, 2000)
      setError(err)
    }
  }

  const handleEditChange = e => {
    const { name, value } = e.target
    setEditData({ ...editData, [name]: value })
  }

  const handleEditSubmit = () => {}

  const handleExtendClick = async booking => {
    setIsExtendModalOpen(true)

    try {
      const response = await apiHandler({
        endpoint: `/backend/bookings/bookingDetails/${booking.id}`,
        method: "GET",
        options: {
          "x-access-token": token || localStorage.getItem("token"),
        },
      })

      setExtendData(response?.data)
    } catch (err) {
      toast.error("Token Expired.. Redirecting to Login Page.....")
      setTimeout(() => {
        navigate("/login")
      }, 2000)
      setError(err)
    }
  }

  const handleExtendSubmit = () => {
    setIsExtendModalOpen(false)
  }

  const handleExtendChange = () => {}

  const handleIncompleteClick = (bookingId, booking) => {
    const loggedInUser = JSON.parse(localStorage.getItem("user"))

    if (loggedInUser.name) {
      const detail = {
        name: loggedInUser.name,
        reference_no: booking?.reference_no,
      }

      sendIncompleteToCompleteAlert(detail)
    }

    setIncompleteModalOpen(true)
    handleFetchBookingDetails(bookingId)
  }

  const isSearchDisabled = () => {
    return Object.values(filters).every(
      value => value === "" || value === undefined
    )
  }

  return (
    <div
      className="p-4"
      style={{
        marginTop: "140px",
        marginBottom: "20px",
      }}
    >
      <h4 style={{ fontWeight: "bold", marginTop: "20px" }}>All Bookings</h4>
      <Form>
        <Row>
          <Col md={1} style={getColStyle("10.666667%")}>
            <FormGroup>
              <label htmlFor="keyword" className="heading-text">
                Keyword
              </label>
              <Input
                type="text"
                name="keyword"
                id="keyword"
                placeholder="Enter keyword"
                value={filters.keyword}
                onChange={handleInputChange}
                className="table-text border-secondary"
              />
            </FormGroup>
          </Col>

          <Col md={1} style={getColStyle("10.5%")}>
            <FormGroup>
              <label htmlFor="key" className="heading-text">
                Key
              </label>
              <Input
                type="select"
                name="keyword_type"
                id="key"
                value={filters?.keyword_type}
                onChange={handleInputChange}
                className="table-text border-secondary"
              >
                <option value="">Select Key</option>
                <option value="reference">Reference Number</option>
                <option value="multi_mode">Multi Mode</option>
                <option value="third_party_reference">
                  Third Party Reference
                </option>
                <option value="mobile_number">Mobile Number</option>
                <option value="reg_no">Reg No</option>
                <option value="email">Email</option>
                <option value="mobile">Mobile</option>
                <option value="first_name">First Name</option>
                <option value="last_name">Last Name</option>
              </Input>
            </FormGroup>
          </Col>

          <Col md={1} style={getColStyle("10.666667%")}>
            <FormGroup>
              <label htmlFor="site" className="heading-text">
                Site
              </label>
              <Input
                type="select"
                name="site_id"
                id="site"
                value={filters?.site_id}
                onChange={handleInputChange}
                className="table-text border-secondary"
              >
                <option value="">Select Site</option>
                {sites.map(site => (
                  <option key={site.id} value={site.id}>
                    {site.name}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>

          <Col md={1}>
            <FormGroup>
              <label htmlFor="airport" className="heading-text">
                Airport
              </label>
              <Input
                type="select"
                name="airport_id"
                id="airport"
                value={filters?.airport_id}
                onChange={handleInputChange}
                className="table-text border-secondary"
              >
                <option value="">Airport</option>
                {airports?.map(airport => (
                  <option key={airport?.id} value={airport?.id}>
                    {airport?.name}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>

          <Col md={1} style={getColStyle("10.666667%")}>
            <FormGroup>
              <label htmlFor="status" className="heading-text">
                Companies
              </label>
              <Input
                type="select"
                name="company_id"
                id="airport"
                value={filters?.company_id}
                onChange={handleInputChange}
                className="table-text border-secondary"
              >
                <option value="">Company</option>
                {companies?.map(company => (
                  <option key={company?.id} value={company?.id}>
                    {company?.name}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>

          <Col md={1} style={getColStyle("10.666667%")}>
            <FormGroup>
              <label htmlFor="type" className="heading-text">
                Date Type
              </label>
              <Input
                type="select"
                name="type"
                id="type"
                value={filters?.type}
                onChange={handleInputChange}
                className="table-text border-secondary"
              >
                <option value="">Type</option>
                <option value="booking">Booking</option>
                <option value="departure">Departure</option>
                <option value="arrival">Arrival</option>
              </Input>
            </FormGroup>
          </Col>

          <Col md={1}>
            <FormGroup>
              <label htmlFor="status" className="heading-text">
                Status
              </label>
              <Input
                type="select"
                name="status"
                id="airport"
                value={filters?.status}
                onChange={handleInputChange}
                className="table-text border-secondary"
              >
                <option value="all">All</option>
                <option value="completed">Active</option>
                <option value="incompleted">InActive</option>
                <option value="cancelled">Cancelled</option>
              </Input>
            </FormGroup>
          </Col>

          <Col md={1} style={getColStyle("10.666667%")}>
            <FormGroup>
              <label htmlFor="fromDate" className="heading-text">
                From Date
              </label>
              <DatePicker
                selected={filters?.from_date || null}
                onChange={date =>
                  handleInputChange({
                    target: {
                      name: "from_date",
                      value: moment(date).format("YYYY-MM-DD"),
                    },
                  })
                }
                className="table-text border-secondary form-control"
                dateFormat="dd-MMM-yyyy"
                placeholderText="DD-MM-YYYY"
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
              />
            </FormGroup>
          </Col>

          <Col md={1} style={getColStyle("10.666667%")}>
            <FormGroup>
              <label htmlFor="toDate" className="heading-text">
                To Date
              </label>
              <DatePicker
                selected={filters.to_date || null}
                onChange={date =>
                  handleInputChange({
                    target: {
                      name: "to_date",
                      value: moment(date).format("YYYY-MM-DD"),
                    },
                  })
                }
                className="table-text border-secondary form-control"
                dateFormat="dd-MMM-yyyy"
                placeholderText="DD-MM-YYYY"
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
              />
            </FormGroup>
          </Col>

          <Col md={1} className="d-flex align-items-center">
            <Button
              color="primary"
              onClick={handleSearch}
              disabled={isSearchDisabled()}
              style={{
                width: "60px",
                height: "30px",
                fontSize: "11px",
                marginTop: "14px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              Search
            </Button>
          </Col>
        </Row>
      </Form>

      <Row>
        <Col md={2} className="d-flex align-items-center">
          <label
            for="bookingsPerPage"
            className="heading-text d-flex justify-content-start align-items-center mb-0"
            style={{ width: "500px" }}
          >
            Bookings Per Page
          </label>
          <Input
            type="select"
            name="bookingsPerPage"
            id="bookingsPerPage"
            value={bookingPerPage}
            onChange={e => {
              setBookingsPerPage(Number(e.target.value))
              setCurrentPage(1)
            }}
            className="table-text ms-2 border-secondary"
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={30}>30</option>
            <option value={40}>40</option>
            <option value={50}>50</option>
            <option value={60}>60</option>
            <option value={70}>70</option>
            <option value={80}>80</option>
            <option value={90}>90</option>
            <option value={100}>100</option>
            {/* <option value='all'>All</option> */}
          </Input>
        </Col>
        <Col md={2} className="d-flex justify-content-start align-items-center">
          <FiRefreshCw
            onClick={refreshBookings}
            style={{
              cursor: "pointer",
              color: "blue",
              fontSize: "25px",
              fontWeight: "bolder",
            }}
            title="Refresh Bookings"
          />
        </Col>

        {/* <Col md={8} className='d-flex justify-content-end align-items-center'>
        <Button 
            color="danger" 
            onClick={handleDelete} 
            disabled={selectedBookings.length === 0} 
            size='sm'
          >
            Delete Selected
          </Button>
          </Col> */}

        {/* Dashboard Deatils  */}
      </Row>
      <div className="custom-table-wrapper ">
        <Table className="custom-table" striped bordered hover responsive>
          <thead>
            <tr className="heading-text">
              {/* <th >
                <Input type="checkbox"
                  checked={selectedBookings.length === bookings.length && bookings.length > 0}
                  onClick={handleSelectAll}

                  className="border-primary" />
              </th> */}
              <th>
                <p>#</p>
              </th>

              <th>
                <p>Reference</p>
              </th>
              <th>
                <p>Site</p>
              </th>
              <th>
                <p>Company</p>
              </th>
              <th>
                <p>Name</p>
              </th>
              <th>
                <p>Contact</p>
              </th>
              <th>
                <p>Vehicle Reg No</p>
              </th>
              <th>
                <p>Created At</p>
              </th>
              <th>
                <p>Departure Date Time</p>
              </th>

              <th>
                <p>Amount</p>
              </th>
              <th>
                <p>Email</p>
              </th>
              <th>
                <p>A.Email</p>
              </th>
              <th>
                <p>SMS</p>
              </th>
              <th>
                <p>CNC</p>
              </th>
              <th>
                <p>Promo</p>
              </th>
              {/* <th>
                <p>
                  Status
                </p>
              </th> */}
              <th className="text-center">
                <p>Action</p>
              </th>
              {(userId == 1 || userId == 38) && (
                <th>
                  <p>Delete</p>
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td
                  colSpan="17"
                  className="text-center"
                  style={{ height: "200px" }}
                >
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "100%" }}
                  >
                    <CustomLoader />
                  </div>
                </td>
              </tr>
            ) : bookings?.length === 0 ? (
              <tr>
                <td
                  colSpan="17"
                  className="text-center w-100"
                  style={{ margin: "20px 0px" }}
                >
                  Booking Not Available
                </td>
              </tr>
            ) : (
              bookings?.map((booking, index) => {
                const countdownTime = countdowns[booking.id] || 0 // Default to 0 if undefined
                const nowUK = moment().tz("Europe/London").valueOf()
                const timeLeft =
                  countdownTime > nowUK ? countdownTime - nowUK : 0 // Prevent NaN

                const minutes = Math.floor(
                  (timeLeft % (1000 * 60 * 60)) / (1000 * 60)
                )
                const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000)

                let currentDate = moment()
                  .tz("Europe/London")
                  .format("DD-MM-YYYY HH:mm:ss")

                return (
                  <tr
                    key={booking.id}
                    className={
                      timeLeft > 0 &&
                      booking?.bookingDetails[0]?.status === "incompleted"
                        ? "table-text table-success"
                        : booking?.email_link &&
                          moment(booking?.email_link)
                            .tz("Europe/London")
                            .format("DD-MM-YYYY HH:mm:ss") > currentDate &&
                          booking?.bookingDetails[0]?.status === "incompleted"
                        ? "table-text table-info"
                        : "table-text"
                    }
                  >
                    <td>
                      <p>{(currentPage - 1) * bookingPerPage + index + 1}</p>
                    </td>

                    <td
                      style={{
                        color:
                          booking?.bookingDetails[0]?.status === "cancelled"
                            ? "red"
                            : "inherit",
                      }}
                    >
                      <p>{booking?.reference_no}</p>
                    </td>
                    <td>
                      <p>
                        {booking?.bookingDetails[0]?.company?.sku_tag
                          ? `${booking?.bookingDetails[0]?.company?.sku_tag}/${
                              booking?.bookingDetails[0]?.icampaign
                                ? booking?.bookingDetails[0]?.icampaign
                                : ""
                            }`
                          : `${
                              booking?.site?.name
                                ? booking.site.name
                                    .trim()
                                    .split(/\s+/)
                                    .map(word => word.charAt(0))
                                    .join("")
                                : "N/A"
                            }/${
                              booking?.bookingDetails[0]?.icampaign
                                ? booking?.bookingDetails[0]?.icampaign
                                : ""
                            }`}
                      </p>
                    </td>
                    <td>
                      <p>{booking?.bookingDetails[0]?.company?.name}</p>
                    </td>
                    <td>
                      <p>
                        {booking?.bookingDetails[0]?.customer.first_name}{" "}
                        {booking?.bookingDetails[0]?.customer.last_name}
                      </p>
                    </td>
                    <td>
                      <p>
                        {timeLeft > 0 &&
                        booking?.bookingDetails[0]?.status === "incompleted"
                          ? `${minutes}:${
                              seconds < 10 ? `0${seconds}` : seconds
                            }`
                          : booking?.bookingDetails[0]?.customer?.contact_no}
                      </p>
                    </td>
                    <td>
                      <p>
                        {booking?.bookingDetails[0]?.vehicle.reg_no == 0
                          ? "TBC"
                          : booking?.bookingDetails[0]?.vehicle.reg_no}
                      </p>
                    </td>
                    <td>
                      <p>
                        {moment(booking?.createdAt)
                          .tz("Europe/London")
                          .format("DD-MMM-YYYY HH:mm:ss")}
                      </p>
                    </td>
                    <td>
                      <p>
                        {moment(
                          booking?.bookingDetails[0].departure_date
                        ).format("DD-MM-YYYY")}{" "}
                        {moment(
                          booking?.bookingDetails[0]?.departure_time,
                          "HH:mm:ss"
                        ).format("HH:mm")}
                      </p>
                    </td>
                    <td>
                      <p>
                        {(() => {
                          const payment = booking?.bookingDetails[0]?.payment
                          if (!payment) return "N/A"

                          const amount = parseFloat(payment.amount) || 0
                          const extraCharges =
                            parseFloat(payment.extra_charges) || 0
                          const adminCharges =
                            parseFloat(payment.admin_charges) || 0
                          const smsCharges =
                            parseFloat(payment.sms_charges) || 0
                          const discount = parseFloat(payment.discount) || 0
                          const refundedAmount =
                            parseFloat(payment.refunded_amount) || 0
                          const cancellationCharges =
                            parseFloat(payment.cancellation_charges) || 0

                          const totalAmount =
                            amount +
                            extraCharges +
                            adminCharges +
                            smsCharges -
                            discount +
                            cancellationCharges

                          return `${totalAmount.toFixed(2)}`
                        })()}
                      </p>
                    </td>
                    <td>
                      <p>
                        {booking?.bookingDetails[0]?.email_status == "sent" ? (
                          <IoIosCheckmarkCircle className="text-success  fs-4 text-center mx-2" />
                        ) : (
                          <HiXCircle className="text-danger fs-4 text-center mx-2" />
                        )}
                      </p>
                    </td>
                    <td>
                      <p>
                        {booking?.bookingDetails[0]?.company_email_status ==
                        "sent" ? (
                          <IoIosCheckmarkCircle className="text-success  fs-4 text-center mx-2" />
                        ) : (
                          <HiXCircle className="text-danger fs-4 text-center mx-2" />
                        )}
                      </p>
                    </td>
                    <td>
                      <p>
                        {booking?.bookingDetails[0]?.sms_status == "sent" ? (
                          <IoIosCheckmarkCircle className="text-success  fs-4 text-center mx-2" />
                        ) : (
                          <HiXCircle className="text-danger fs-4 text-center mx-2" />
                        )}
                      </p>
                    </td>

                    <td>
                      <p>
                        {booking?.bookingDetails[0]?.cancellation_status ==
                        "1" ? (
                          <IoIosCheckmarkCircle className="text-success  fs-4 text-center mx-2" />
                        ) : (
                          <HiXCircle className="text-danger fs-4 text-center mx-2" />
                        )}
                      </p>
                    </td>
                    <td>
                      <p>
                        {booking?.bookingDetails[0]?.payment?.discount > 0 ? (
                          <IoIosCheckmarkCircle className="text-success  fs-4 text-center mx-2" />
                        ) : (
                          <HiXCircle className="text-danger fs-4 text-center mx-2" />
                        )}
                      </p>
                    </td>
                    <td
                      style={{ textAlign: "center", verticalAlign: "middle" }}
                    >
                      <div className="d-flex  align-items-center justify-content-center">
                        {booking?.bookingNotes?.length > 0 && (
                          <div
                            className="mb-1 "
                            style={{
                              width: "0%",
                              position: "relative",
                              left: "-20px",
                              top: "4px",
                            }}
                          >
                            <SeeNotes
                              Booking_ID={booking?.id}
                              BookingNote={booking?.bookingNotes}
                            />
                          </div>
                        )}

                        {booking?.bookingDetails[0].status !== "incompleted" ? (
                          <BookingDetails
                            onBookingDetails={() => {
                              handleFetchBookingDetails(booking?.id)
                              toggleModal(true)
                            }}
                            onBookingHistory={() =>
                              handleFetchBookingHistory(booking?.id)
                            }
                            className={
                              booking?.bookingDetails[0]?.status === "cancelled"
                                ? "btn btn-danger"
                                : (booking?.third_party_reference == "" &&
                                    booking?.bookingDetails[0]?.company
                                      ?.sku_tag === "fhr") ||
                                  (booking?.third_party_reference == "" &&
                                    booking?.bookingDetails[0]?.company
                                      ?.sku_tag === "a2z")
                                ? "btn btn-dark"
                                : "btn btn-success"
                            }
                          />
                        ) : (
                          <button
                            className={
                              booking?.email_link > currentDate ||
                              booking?.status ||
                              booking?.bookingDetails[0]?.booking_type ===
                                "backend"
                                ? "btn btn-info"
                                : "btn btn-warning"
                            }
                            style={{
                              fontSize: "11px",
                              padding: "0px 5px",
                              textAlign: "center",
                            }}
                            onClick={() =>
                              handleIncompleteClick(booking?.id, booking)
                            }
                            disabled={
                              timeLeft > 0 &&
                              booking?.bookingDetails[0]?.booking_type !==
                                "backend"
                            }
                          >
                            {booking?.email_link > currentDate
                              ? "Email Sent"
                              : booking?.status
                              ? booking?.status
                              : booking?.bookingDetails[0]?.booking_type ===
                                "backend"
                              ? `${booking?.bookingDetails[0]?.user?.first_name} `
                              : incompleteUser?.reference_no ===
                                  booking?.reference_no && incompleteUser?.name
                              ? `${
                                  incompleteUser?.name?.split(" ")[0]
                                } on working`
                              : "Incomplete"}
                          </button>
                        )}
                      </div>
                    </td>

                    {(userId == 1 || userId == 38) && (
                      <td>
                        <button
                          className="btn btn-danger"
                          style={{
                            fontSize: "11px",
                            padding: "0px 5px",
                            textAlign: "center",
                          }}
                          onClick={() => handleDeleteClick(booking)}
                          size="sm"
                        >
                          Delete
                        </button>
                      </td>
                    )}
                  </tr>
                )
              })
            )}

            {/* Incomplete Booking Modal  */}

            {/* booking details  */}

            <Modal isOpen={isModalOpen} toggle={toggleModal} fullscreen>
              <ModalBody style={{ fontSize: "11px" }}>
                {bookingDetails?.bookingDetails?.length ? (
                  <Row
                    style={{
                      backgroundColor: " #e1f0fd",
                      paddingBottom: "20px",
                    }}
                  >
                    {/* Left Section for Booking Details */}
                    <Col md={8} style={{ padding: "10px" }}>
                      <ModalHeader className="p-2">
                        <div className="d-flex flex-column">
                          <div
                            className="d-flex  flex-column"
                            style={{
                              fontSize: "13px",
                              fontWeight: "bold",
                              width: "100%",
                            }}
                          >
                            <div className="d-flex justify-content-between">
                              <div>
                                Reference Number: {bookingDetails?.reference_no}
                              </div>

                              {bookingDetails?.bookingDetails
                                ?.filter(
                                  detail =>
                                    detail?.is_current === true ||
                                    detail?.is_current === 1
                                )
                                ?.map((detail, index) => {
                                  return (
                                    <div key={index}>
                                      Booking Type:{" "}
                                      <Badge
                                        color="success"
                                        style={{
                                          padding: "4px",
                                          fontSize: "10px",
                                          textTransform: "capitalize",
                                        }}
                                      >
                                        {detail?.booking_type}
                                      </Badge>{" "}
                                    </div>
                                  )
                                })}
                            </div>
                            <div className="d-flex justify-content-between mt-2">
                              <div>
                                Third Party Reference Number:{" "}
                                {bookingDetails?.third_party_reference || "N/A"}
                              </div>
                              <p
                                style={{
                                  textTransform: "capitalize",
                                }}
                              >
                                Operator:{" "}
                                {bookingDetails?.bookingDetails[0]?.user
                                  ?.first_name
                                  ? bookingDetails?.bookingDetails[0]?.user
                                      ?.first_name +
                                    " " +
                                    (bookingDetails?.bookingDetails[0]?.user
                                      ?.last_name || "")
                                  : "N/A"}
                              </p>
                            </div>
                          </div>
                        </div>
                      </ModalHeader>
                      {bookingDetails?.bookingDetails
                        ?.filter(
                          detail =>
                            detail?.is_current === true ||
                            detail?.is_current === 1
                        )
                        ?.map((detail, index) => (
                          <Card className="m-0 p-0" key={index}>
                            <CardBody>
                              <Row>
                                {/* Left Section */}
                                <Col md="6">
                                  <Row>
                                    <Col>
                                      <p>
                                        <strong>Book Date Time:</strong>{" "}
                                        {moment(detail?.createdAt)
                                          .tz("Europe/London")
                                          .format("DD-MM-YYYY HH:mm:ss")}
                                      </p>
                                      <p>
                                        <strong>Booking Reference:</strong>{" "}
                                        {bookingDetails?.reference_no}
                                      </p>
                                      <p>
                                        <strong>Airport:</strong>{" "}
                                        {detail?.airport?.name}
                                      </p>
                                      <p>
                                        <strong>Depart Date Time:</strong>{" "}
                                        {moment
                                          .tz(
                                            `${detail?.departure_date} ${detail?.departure_time}`,
                                            "YYYY-MM-DD HH:mm:ss",
                                            "Europe/London"
                                          )
                                          .format("DD-MM-YYYY HH:mm:ss")}
                                      </p>

                                      <p>
                                        <strong>Return Date Time:</strong>{" "}
                                        {moment
                                          .tz(
                                            `${detail?.arrival_date} ${detail?.arrival_time}`,
                                            "YYYY-MM-DD HH:mm:ss",
                                            "Europe/London"
                                          )
                                          .format("DD-MM-YYYY HH:mm:ss")}
                                      </p>

                                      <p>
                                        <strong>Parking For:</strong>{" "}
                                        {detail?.no_of_days} Days
                                      </p>
                                      <p>
                                        <strong>Service Provider:</strong>{" "}
                                        {bookingDetails?.site?.name}
                                      </p>
                                      <p>
                                        <strong>Product Name:</strong>{" "}
                                        {detail?.company?.name}
                                      </p>
                                      <p>
                                        <strong>Service Type:</strong>{" "}
                                        {detail?.company?.type_id == 1
                                          ? "Meet & Greet"
                                          : "Park & Ride"}
                                      </p>
                                      <p>
                                        <strong>Booking Type:</strong>{" "}
                                        {detail?.company?.cancellation_status
                                          ? "Flexible"
                                          : "Non-Flexible"}
                                      </p>
                                      <p>
                                        <strong>API Tag:</strong>{" "}
                                        {detail?.company?.sku_tag}
                                      </p>
                                    </Col>
                                  </Row>
                                </Col>

                                {/* Right Section */}
                                <Col md="6">
                                  <div
                                    className="border p-3 rounded"
                                    style={{
                                      boxShadow:
                                        "1px 1px 2px 1px  rgb(196, 196, 199)",
                                    }}
                                  >
                                    <p>
                                      <strong>Name:</strong>{" "}
                                      {detail?.customer?.title}.{" "}
                                      {detail?.customer?.first_name}{" "}
                                      {detail?.customer?.last_name}
                                    </p>
                                    <p>
                                      <strong>Contact:</strong>{" "}
                                      {detail?.customer?.contact_no}
                                    </p>
                                    <p>
                                      <strong>Email Address:</strong>{" "}
                                      {detail?.customer?.email}
                                    </p>
                                    <CreateNotes
                                      bookingDetails={bookingDetails}
                                      // subscribeKey={subscribeKey}
                                    />
                                    {/* <Button color="warning" size="sm" onClick={toggleEditCustomerModal} style={{ fontSize: '11px', padding: '2px 4px', marginTop: '3px' }}>Edit Customer Detail</Button> */}
                                  </div>
                                </Col>
                              </Row>

                              <Row className="mt-4">
                                <Col>
                                  <div className="custom-table-wrapper">
                                    <Table
                                      striped
                                      bordered
                                      hover
                                      responsive
                                      style={{
                                        tableLayout: "auto",
                                        whiteSpace: "nowrap",
                                        textAlign: "center",
                                      }}
                                    >
                                      <thead>
                                        <tr>
                                          <th>Dep Terminal</th>
                                          <th>Dep Flight</th>
                                          <th>Return Terminal</th>
                                          <th>Return Flight</th>
                                          <th>Make</th>
                                          <th>Model</th>
                                          <th>Color</th>
                                          <th>Reg Number</th>
                                          <th>Passenger(s)</th>
                                          {/* <th>Action</th> */}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td>{detail?.departure_terminal}</td>
                                          <td>{detail?.departure_flight_no}</td>
                                          <td>{detail?.arrival_terminal}</td>
                                          <td>{detail?.arrival_flight_no}</td>
                                          <td>{detail?.vehicle?.make}</td>
                                          <td>{detail?.vehicle?.model}</td>
                                          <td>{detail?.vehicle?.color}</td>
                                          <td>{detail?.vehicle?.reg_no}</td>
                                          <td>{detail?.no_of_peoples}</td>
                                          {/* <td>
                            <Button color="warning" size="sm" onClick={()=> {setIsEditVehicleFlightModalOpen(true)}} style={{ fontSize: '11px', padding: '2px 4px' }}>Edit</Button>
                          </td> */}
                                        </tr>
                                      </tbody>
                                    </Table>
                                  </div>
                                </Col>
                              </Row>

                              <Row>
                                <Col md={6}>
                                  <div className="d-flex justify-content-between">
                                    <p>Promo Code:</p>
                                    <strong>
                                      {detail?.payment?.discount_code}
                                    </strong>
                                  </div>
                                  <div className="d-flex justify-content-between">
                                    <p>SMS / Cancellation Cover</p>
                                    <strong>
                                      {detail?.sms_confirmation == "1"
                                        ? "Yes"
                                        : "No"}{" "}
                                      /{" "}
                                      {detail?.cancellation_status == "1"
                                        ? "Yes"
                                        : "No"}
                                    </strong>
                                  </div>
                                </Col>
                                <Col md={6}>
                                  <div className="d-flex justify-content-between">
                                    <p>Booking Status:</p>
                                    <strong>
                                      {detail?.status === "completed" ? (
                                        <Badge
                                          color="success"
                                          style={{
                                            padding: "4px",
                                            fontSize: "10px",
                                          }}
                                        >
                                          Active
                                        </Badge>
                                      ) : detail?.status === "cancelled" ? (
                                        <Badge
                                          color="danger"
                                          style={{
                                            padding: "4px",
                                            fontSize: "10px",
                                          }}
                                        >
                                          Cancelled
                                        </Badge>
                                      ) : (
                                        <Badge
                                          color="warning"
                                          style={{
                                            padding: "4px",
                                            fontSize: "10px",
                                          }}
                                        >
                                          Inactive
                                        </Badge>
                                      )}
                                    </strong>
                                  </div>
                                  <div className="d-flex justify-content-between mt-1">
                                    <p>Email Status:</p>
                                    <strong>
                                      <Badge
                                        color="success"
                                        style={{
                                          padding: "4px",
                                          fontSize: "10px",
                                        }}
                                      >
                                        Sent
                                      </Badge>
                                    </strong>
                                  </div>
                                  <div className="d-flex justify-content-between mt-1">
                                    <p>Review Status:</p>
                                    <strong>
                                      <Badge
                                        color="warning"
                                        style={{
                                          padding: "4px",
                                          fontSize: "10px",
                                        }}
                                      >
                                        Pending
                                      </Badge>
                                    </strong>
                                  </div>
                                </Col>
                              </Row>

                              {/* Payment Details */}
                              <Row className="mt-4">
                                <Col>
                                  <Table
                                    striped
                                    dotted
                                    hover
                                    responsive
                                    style={{
                                      tableLayout: "auto",
                                      whiteSpace: "nowrap",
                                      padding: "3px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <thead>
                                      <tr>
                                        <th>Quote</th>
                                        <th>Discount</th>
                                        <th>Book Fee</th>
                                        <th>Extra Charges</th>

                                        <th>SMS Charges</th>
                                        <th>Cancel</th>

                                        <th>Total Paid</th>
                                        <th>Transaction Id</th>
                                        {/* <th>Action</th> */}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td>{detail?.payment.amount}</td>
                                        <td>{detail?.payment.discount}</td>
                                        <td>{detail?.payment.admin_charges}</td>
                                        <td>{detail?.payment.extra_charges}</td>
                                        <td>{detail?.payment.sms_charges}</td>

                                        <td>
                                          {detail?.payment.cancellation_charges}
                                        </td>
                                        <td>
                                          {(
                                            (parseFloat(
                                              detail?.payment.amount
                                            ) || 0) +
                                            (parseFloat(
                                              detail?.payment
                                                .cancellation_charges
                                            ) || 0) +
                                            (parseFloat(
                                              detail?.payment.sms_charges
                                            ) || 0) +
                                            (parseFloat(
                                              detail?.payment.levy_charges
                                            ) || 0) +
                                            (parseFloat(
                                              detail?.payment.valet_charges
                                            ) || 0) +
                                            (parseFloat(
                                              detail?.payment.admin_charges
                                            ) || 0) +
                                            (parseFloat(
                                              detail?.payment.extra_charges
                                            ) || 0) -
                                            (parseFloat(
                                              detail?.payment.discount
                                            ) || 0)
                                          ).toFixed(2)}
                                        </td>
                                        <td>
                                          {detail?.payment.transaction_id}
                                        </td>
                                        {/* <td>
                          <Button color="warning" size="sm" onClick={()=> {setIsEditPaymentModalOpen(true)}} style={{ fontSize: '11px', padding: '2px 4px' }}>Edit</Button>
                        </td> */}
                                      </tr>
                                      <tr>
                                        <td>{detail?.payment.amount}</td>
                                        <td>{detail?.payment.discount}</td>
                                        <td>{detail?.payment.admin_charges}</td>
                                        <td>{detail?.payment.extra_charges}</td>

                                        <td>{detail?.payment.sms_charges}</td>

                                        <td>
                                          {detail?.payment.cancellation_charges}
                                        </td>

                                        <td>
                                          {(
                                            (parseFloat(
                                              detail?.payment.amount
                                            ) || 0) +
                                            (parseFloat(
                                              detail?.payment
                                                .cancellation_charges
                                            ) || 0) +
                                            (parseFloat(
                                              detail?.payment.sms_charges
                                            ) || 0) +
                                            (parseFloat(
                                              detail?.payment.levy_charges
                                            ) || 0) +
                                            (parseFloat(
                                              detail?.payment.valet_charges
                                            ) || 0) +
                                            (parseFloat(
                                              detail?.payment.admin_charges
                                            ) || 0) +
                                            (parseFloat(
                                              detail?.payment.extra_charges
                                            ) || 0) -
                                            (parseFloat(
                                              detail?.payment.discount
                                            ) || 0)
                                          ).toFixed(2)}
                                        </td>
                                        <td>
                                          <span
                                            style={{
                                              fontSize: "12px",
                                              textTransform: "capitalize",
                                            }}
                                          >
                                            {detail?.payment?.type}
                                          </span>{" "}
                                          status:
                                          <Badge
                                            color="success"
                                            style={{
                                              padding: "4px",
                                              fontSize: "10px",
                                            }}
                                          >
                                            Completed
                                          </Badge>
                                        </td>
                                        {/* <td>
                                          <Button
                                            color="primary"
                                            size="sm"
                                            style={{
                                              fontSize: "11px",
                                              padding: "2px 4px",
                                            }}
                                          >
                                            Add
                                          </Button>
                                        </td> */}
                                      </tr>
                                    </tbody>
                                  </Table>
                                </Col>
                              </Row>

                              {/* Buttons to switch between tabs */}
                              <Row className="mt-2 mb-2">
                                <Col>
                                  <Button
                                    color={
                                      activeTab === "emailEvents"
                                        ? "primary"
                                        : "secondary"
                                    }
                                    size="sm"
                                    onClick={() => setActiveTab("emailEvents")}
                                    className="me-2"
                                  >
                                    Email Events
                                  </Button>
                                  <Button
                                    color={
                                      activeTab === "procedure"
                                        ? "primary"
                                        : "secondary"
                                    }
                                    size="sm"
                                    onClick={() => setActiveTab("procedure")}
                                    className="me-2"
                                  >
                                    Procedure
                                  </Button>
                                </Col>
                              </Row>

                              {renderTable()}
                            </CardBody>
                          </Card>
                        ))}
                    </Col>

                    {/* Right Section for Edit Customer Details */}
                    <Col md={4} style={{}}>
                      {bookingDetails?.bookingDetails[0]?.status ==
                        "completed" && (
                        <Nav
                          style={{
                            height: "60px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontWeight: "bold",
                            marginBottom: "10px",
                            padding: "10px 0px",
                            gap: "4px",
                          }}
                        >
                          {bookingDetails?.bookingDetails[0]?.company
                            ?.sku_tag == "fhr" ? (
                            ""
                          ) : (
                            <>
                              <NavItem>
                                <Button
                                  className={
                                    activeTab === "editCustomer" ? "active" : ""
                                  }
                                  onClick={() => toggleTab("editCustomer")}
                                  style={{ fontSize: "11px" }}
                                  color="primary"
                                  size="sm"
                                >
                                  Edit Customer
                                </Button>
                              </NavItem>
                              <NavItem>
                                <Button
                                  className={
                                    activeTab === "amendDates" ? "active" : ""
                                  }
                                  onClick={() => toggleTab("amendDates")}
                                  style={{
                                    fontSize: "11px",
                                    marginLeft: "5px",
                                  }}
                                  color="success"
                                  size="sm"
                                >
                                  Amend Dates
                                </Button>
                              </NavItem>
                              <NavItem>
                                <Button
                                  className={
                                    activeTab === "shiftBooking" ? "active" : ""
                                  }
                                  onClick={() => toggleTab("shiftBooking")}
                                  style={{
                                    fontSize: "11px",
                                    marginLeft: "5px",
                                  }}
                                  color="info"
                                  size="sm"
                                >
                                  Transfer Booking
                                </Button>
                              </NavItem>{" "}
                            </>
                          )}

                          <NavItem>
                            <Button
                              className={
                                activeTab === "cancelBooking" ? "active" : ""
                              }
                              onClick={() => toggleTab("cancelBooking")}
                              style={{ fontSize: "11px", marginRight: "5px" }}
                              color="danger"
                              size="sm"
                            >
                              Cancel Booking
                            </Button>
                          </NavItem>
                          <NavItem>
                            <Button
                              className={
                                activeTab === "emailTab" ? "active" : ""
                              }
                              onClick={() => toggleTab("emailTab")}
                              style={{ fontSize: "11px" }}
                              color="secondary"
                              size="sm"
                            >
                              Send Email Confirmation
                            </Button>
                          </NavItem>
                        </Nav>
                      )}

                      <div>
                        {activeTab == "emailTab" && (
                          <EmailModal setActiveTab={setActiveTab} />
                        )}

                        {activeTab === "editCustomer" ||
                        activeTab === "editBooking" ? (
                          <EditCustomerTravelDetails
                            public_key={public_key}
                            activeTab={activeTab}
                            bookingDetails={bookingDetails}
                            combinedData={combinedData}
                            setActiveTab={setActiveTab}
                            setCombinedData={setCombinedData}
                            handleCombinedChange={handleCombinedChange}
                            handleCombinedSubmit={handleCombinedSubmit}
                            handleFetchBookingDetails={
                              handleFetchBookingDetails
                            }
                          />
                        ) : null}
                      </div>

                      {activeTab == "cancelBooking" && (
                        <CancelBookingModal setActiveTab={setActiveTab} />
                      )}

                      {activeTab === "shiftBooking" &&
                        bookingDetails?.bookingDetails
                          ?.filter(
                            detail =>
                              detail?.is_current === true ||
                              detail?.is_current === 1
                          )
                          ?.map((detail, index) => (
                            <TransferBookingModal
                              public_key={public_key}
                              handleFetchBookingDetails={
                                handleFetchBookingDetails
                              }
                              setActiveTab={setActiveTab}
                            />
                          ))}
                      {activeTab == "amendDates" && (
                        <AmendDates
                          public_key={public_key}
                          isOpen={isAmendDatesModalOpen}
                          toggle={toggleAmendDatesModal}
                          bookingDetails={selectedBooking}
                          onSubmit={handleAmendDatesSubmit}
                          setActiveTab={setActiveTab}
                          handleFetchBookingDetails={handleFetchBookingDetails}
                        />
                      )}
                    </Col>
                  </Row>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "500px",
                    }}
                  >
                    <Loader />
                  </div>
                )}

                <div
                  className="mt-2"
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    alignItems: "center",
                  }}
                >
                  <Button
                    color="danger"
                    size="md"
                    onClick={() => {
                      setIsModalOpen(false)
                      toggleTab("")
                      setActiveTab("")
                    }}
                    style={{
                      width: "150px",
                      boxShadow: "3px 3px 3px rgb(57, 57, 58)",
                    }}
                  >
                    Close
                  </Button>
                </div>
              </ModalBody>
            </Modal>

            {/* Amend Dates  */}

            <Modal isOpen={isEditModalOpen} toggle={toggleEditModal} size="lg">
              <ModalHeader toggle={() => setIsEditModalOpen(false)}>
                Amend Dates
              </ModalHeader>
              <ModalBody>
                <div className="form-inline  d-flex justify-content-between">
                  <FormGroup className="inline-form-group">
                    <label for="departDate">Depart Date*</label>
                    <Input
                      type="text"
                      name="departDate"
                      id="departDate"
                      value="Thu, 26 Dec 2024"
                      disabled
                    />
                  </FormGroup>
                  <FormGroup className="inline-form-group">
                    <label for="dropOffTime">Drop-Off Time*</label>
                    <Input type="select" name="dropOffTime" id="dropOffTime">
                      <option value="06:30">06:30</option>
                    </Input>
                  </FormGroup>
                  <FormGroup className="inline-form-group">
                    <label for="returnDate">Return Date*</label>
                    <Input
                      type="text"
                      name="returnDate"
                      id="returnDate"
                      value="Sat, 28 Dec 2024"
                      disabled
                    />
                  </FormGroup>
                  <FormGroup className="inline-form-group">
                    <label for="pickUpTime">Pick-Up Time*</label>
                    <Input type="select" name="pickUpTime" id="pickUpTime">
                      <option value="23:45">23:45</option>
                    </Input>
                  </FormGroup>
                </div>
                <div>
                  <Button color="warning" size="sm" className="mb-3">
                    Get Quote
                  </Button>
                </div>
                <h5>Quote Details</h5>
                <div className="alert alert-warning" role="alert">
                  New Quote Amount 59.99 is Greater than Quoted Amount 42.99.{" "}
                  <br /> Please Charge The Quote Difference Amount 17.00 To
                  Customer.
                </div>
                <div className="d-flex justify-content-between">
                  <FormGroup>
                    <label for="quoteDifference">Quote Difference*</label>
                    <Input
                      type="text"
                      name="quoteDifference"
                      id="quoteDifference"
                      value="17.00"
                      disabled
                    />
                  </FormGroup>
                  <FormGroup>
                    <label for="adminCharges">Admin Charges*</label>
                    <Input
                      type="text"
                      name="adminCharges"
                      id="adminCharges"
                      value="10.00"
                      disabled
                    />
                  </FormGroup>
                  <FormGroup>
                    <label for="payableAmount">Payable Amount*</label>
                    <Input
                      type="text"
                      name="payableAmount"
                      id="payableAmount"
                      value="27.00"
                      disabled
                    />
                  </FormGroup>
                  <FormGroup>
                    <label for="paymentOption">Payment Option:</label>
                    <Input
                      type="select"
                      name="paymentOption"
                      id="paymentOption"
                    >
                      <option>Select Option</option>
                      <option value="creditCard">Stripe</option>
                      <option value="creditCard">Credit Card</option>
                      <option value="paypal">PayPal</option>
                    </Input>
                  </FormGroup>
                </div>

                <h5>Confirmation Options</h5>
                <FormGroup check>
                  <label check>
                    <Input type="checkbox" /> Send Confirmation To Customer
                  </label>
                </FormGroup>
                <FormGroup check>
                  <label check>
                    <Input type="checkbox" /> Send Confirmation To Company
                  </label>
                </FormGroup>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="secondary"
                  onClick={() => setIsEditModalOpen(false)}
                >
                  Cancel
                </Button>
                <Button
                  color="primary"
                  onClick={() => setIsEditModalOpen(false)}
                >
                  Submit
                </Button>
              </ModalFooter>
            </Modal>

            {/* Booking history */}
            <Modal
              isOpen={isBookingHistoryModalOpen}
              toggle={toggleBookingHistoryModal}
              size="xl"
            >
              <ModalHeader
                toggle={toggleModal}
                className="custom-modal-header w-100 text-white"
              >
                <div className="d-flex flex-column w-100">
                  <div
                    className="d-flex justify-content-between"
                    style={{
                      fontSize: "13px",
                      fontWeight: "bold",
                    }}
                  >
                    <div className="text-white">Booking History</div>
                    <div className="text-white">
                      Multimode Ref Number: {bookingHistory?.multi_mode}
                    </div>
                    <div className="text-white">
                      Reference Number: {bookingHistory?.reference_no}
                    </div>
                    {bookingHistory?.bookingDetails
                      ?.filter(
                        detail =>
                          detail?.is_current === true ||
                          detail?.is_current === 1
                      )
                      ?.map((detail, index) => (
                        <>
                          <div className="text-white">
                            Booking Type: {detail?.booking_type}
                          </div>
                        </>
                      ))}
                  </div>
                </div>
              </ModalHeader>
              {bookingHistory?.bookingDetails
                ?.slice()
                .reverse()
                .map((booking, index) => (
                  <div
                    key={index}
                    style={{
                      border: "2px solid blue",
                      margin: "10px",
                    }}
                  >
                    <ModalBody>
                      <div className="row w-100 mb-3 bg-light p-4">
                        <div
                          className="col-md-4"
                          style={{
                            fontSize: "11px",
                          }}
                        >
                          <p>
                            £ Price: £{" "}
                            {(parseFloat(booking?.payment.amount) || 0) +
                              (parseFloat(
                                booking?.payment.cancellation_charges
                              ) || 0) +
                              (parseFloat(booking?.payment.sms_charges) || 0) +
                              (parseFloat(booking?.payment.levy_charges) || 0) +
                              (parseFloat(booking?.payment.valet_charges) ||
                                0) +
                              (parseFloat(booking?.payment.admin_charges) ||
                                0) +
                              (parseFloat(booking?.payment.extra_charges) ||
                                0) -
                              (parseFloat(booking?.payment.discount) || 0)}
                          </p>
                        </div>

                        <div
                          className="col-md-4"
                          style={{
                            fontSize: "11px",
                          }}
                        >
                          <p>
                            {moment(booking?.createdAt)
                              .tz("Europe/London")
                              .format("DD-MM-YYYY HH:mm:ss")}
                          </p>
                        </div>

                        <div
                          className="col-md-4"
                          style={{
                            fontSize: "11px",
                          }}
                        >
                          <p>
                            Current Status:{" "}
                            <Button
                              color={
                                booking?.status === "completed"
                                  ? "success"
                                  : "warning"
                              }
                              size="sm"
                            >
                              {booking?.status}
                            </Button>
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div
                          className="col-md-3"
                          style={{
                            fontSize: "11px",
                          }}
                        >
                          <h5
                            style={{
                              fontSize: "13px",
                            }}
                          >
                            Booking Details
                          </h5>
                          <p>
                            {" "}
                            Departure Date Time:
                            {moment(booking?.departure_date).format(
                              "YYYY-MMM-DD "
                            )}
                            {moment(booking?.departure_time, "HH:mm:ss").format(
                              "hh:mm A"
                            )}
                          </p>
                          <p>
                            Arrival Date Time:{" "}
                            {moment(booking?.arrival_date).format(
                              "YYYY-MMM-DD "
                            )}
                            {moment(booking?.arrival_time, "HH:mm:ss").format(
                              "hh:mm A"
                            )}
                          </p>
                          <p>No Of Days: {booking?.no_of_days}</p>
                          <p>
                            Departure Terminal: {booking?.departure_terminal}
                          </p>
                          <p>Arrival Terminal: {booking?.arrival_terminal}</p>
                          <p>
                            Departure Flight No: {booking?.departure_flight_no}
                          </p>
                          <p>Arrival Flight No: {booking?.arrival_flight_no}</p>
                        </div>

                        <div
                          className="col-md-3"
                          style={{
                            fontSize: "11px",
                          }}
                        >
                          <h5
                            style={{
                              fontSize: "13px",
                            }}
                          >
                            Customer Details
                          </h5>
                          <p>
                            {" "}
                            Name: {booking?.customer?.first_name}{" "}
                            {booking?.customer?.last_name}
                          </p>
                          <p>Email: {booking?.customer?.email}</p>
                          <p>Mobile: {booking?.customer?.contact_no}</p>
                          <p>No of People: {booking?.no_of_peoples}</p>
                        </div>

                        <div
                          className="col-md-3"
                          style={{
                            fontSize: "11px",
                          }}
                        >
                          <h5
                            style={{
                              fontSize: "13px",
                            }}
                          >
                            Vehicle Details
                          </h5>
                          <p> Make: {booking?.vehicle?.make}</p>
                          <p>Model: {booking?.vehicle?.model}</p>
                          <p>Color: {booking?.vehicle?.color}</p>
                          <p>Reg No: {booking?.vehicle?.reg_no}</p>
                        </div>

                        <div
                          className="col-md-3"
                          style={{
                            fontSize: "11px",
                          }}
                        >
                          <h5
                            style={{
                              fontSize: "13px",
                            }}
                          >
                            Payment Details
                          </h5>
                          <p>Quote Amount: £{booking?.payment?.amount}</p>
                          <p>
                            Admin Charges: £{booking?.payment?.admin_charges}
                          </p>
                          <p>SMS Charges: £{booking?.payment?.sms_charges}</p>
                          <p>
                            Cancellation Charges: £
                            {booking?.payment?.cancellation_charges}
                          </p>
                          <p>
                            Transaction ID: {booking?.payment?.transaction_id}
                          </p>
                          <p>Discount: £{booking?.payment?.discount}</p>
                          <p>
                            Discount Code:{" "}
                            {booking?.payment?.discount_code || "N/A"}
                          </p>
                          <p>
                            Extra Amount: £{booking?.payment?.extra_charges}
                          </p>
                          <p>Levy Charges: £{booking?.payment?.levy_charges}</p>
                          <p>
                            Valet Charges: £{booking?.payment?.valet_charges}
                          </p>
                          <p>
                            Payment Method: {booking?.payment?.type || "N/A"}{" "}
                          </p>
                          <p>Commission: £ {booking?.company?.commission} </p>
                        </div>
                      </div>
                    </ModalBody>
                    <ModalFooter>
                      <div className="row w-100">
                        <div
                          className="col-md-4"
                          style={{
                            fontSize: "11px",
                          }}
                        >
                          <p>Company: {booking?.company?.name}</p>
                          <p>Company Contact: {booking?.company?.contact}</p>
                          <p>Notes & Information: {booking?.instructions}</p>
                        </div>

                        <div
                          className="col-md-4"
                          style={{
                            fontSize: "11px",
                          }}
                        >
                          <p>Airport: {booking?.airport?.name}</p>
                          <p>Site: {bookingHistory?.site?.name}</p>
                          <p>
                            Third Party Reference:{" "}
                            {bookingHistory?.third_party_reference || "N/A"}
                          </p>
                        </div>

                        <div
                          className="col-md-4"
                          style={{
                            fontSize: "11px",
                          }}
                        >
                          {/* <p>Operator: {booking?.operator || "N/A"}</p> */}
                        </div>
                      </div>
                    </ModalFooter>
                  </div>
                ))}
            </Modal>

            {/* Edit Modal  */}
            <Modal size="xl">
              <ModalHeader
                toggle={toggleEditModal}
                className="custom-modal-header w-100"
              >
                <div className="d-flex flex-column w-100">
                  <div
                    className="d-flex justify-content-between"
                    style={{
                      fontSize: "13px",
                      fontWeight: "bold",
                    }}
                  >
                    <div>
                      Booking Reference Number: {editData?.reference_no}
                    </div>
                    <div>
                      Company:{" "}
                      {editData?.bookingDetails?.length
                        ? editData?.bookingDetails[0]?.company.name
                        : null}
                    </div>
                  </div>
                </div>
              </ModalHeader>
              <ModalBody>
                {editData?.bookingDetails
                  ?.filter(
                    edit => edit?.is_current === true || edit?.is_current === 1
                  )
                  ?.map((edit, index) => (
                    <Form key={index}>
                      {/* Personal Details */}
                      <div
                        className="p-5 mb-3"
                        style={{ border: "2px solid blue" }}
                      >
                        <h5 style={{ fontSize: "11px", fontWeight: "bold" }}>
                          Personal Details
                        </h5>
                        <Row>
                          <Col md={6}>
                            <FormGroup>
                              <label
                                for="firstName"
                                style={{ fontSize: "11px" }}
                              >
                                First Name
                              </label>
                              <Input
                                type="text"
                                name="firstName"
                                id="firstName"
                                value={edit?.customer?.first_name || ""}
                                onChange={handleEditChange}
                                style={{
                                  border: "1px solid #e9ecef",
                                  fontSize: "11px",
                                }}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <label
                                for="lastName"
                                style={{ fontSize: "11px" }}
                              >
                                Last Name
                              </label>
                              <Input
                                type="text"
                                name="lastName"
                                id="lastName"
                                value={edit?.customer?.last_name || ""}
                                onChange={handleEditChange}
                                style={{
                                  border: "1px solid #e9ecef",
                                  fontSize: "11px",
                                }}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={6}>
                            <FormGroup>
                              <label for="contact" style={{ fontSize: "11px" }}>
                                Contact
                              </label>
                              <Input
                                type="text"
                                name="contact"
                                id="contact"
                                value={edit?.customer?.contact_no || ""}
                                onChange={handleEditChange}
                                style={{
                                  border: "1px solid #e9ecef",
                                  fontSize: "11px",
                                }}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <label for="contact" style={{ fontSize: "11px" }}>
                                Email
                              </label>
                              <Input
                                type="text"
                                name="email"
                                id="email"
                                value={edit?.customer?.email || ""}
                                onChange={handleEditChange}
                                style={{
                                  border: "1px solid #e9ecef",
                                  fontSize: "11px",
                                }}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </div>

                      {/* Vehicle Details */}
                      <div
                        className="p-5 mb-3"
                        style={{ border: "2px solid blue" }}
                      >
                        <h5 style={{ fontSize: "11px", fontWeight: "bold" }}>
                          Vehicle Details
                        </h5>
                        <Row>
                          <Col md={6}>
                            <FormGroup>
                              <label for="make" style={{ fontSize: "11px" }}>
                                Make
                              </label>
                              <Input
                                type="text"
                                name="make"
                                id="make"
                                value={edit?.vehicle?.make || ""}
                                onChange={handleEditChange}
                                style={{
                                  border: "1px solid #e9ecef",
                                  fontSize: "11px",
                                }}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <label for="model" style={{ fontSize: "11px" }}>
                                Model
                              </label>
                              <Input
                                type="text"
                                name="model"
                                id="model"
                                value={edit?.vehicle?.model || ""}
                                onChange={handleEditChange}
                                style={{
                                  border: "1px solid #e9ecef",
                                  fontSize: "11px",
                                }}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={6}>
                            <FormGroup>
                              <label for="color" style={{ fontSize: "11px" }}>
                                Color
                              </label>
                              <Input
                                type="text"
                                name="color"
                                id="color"
                                value={edit?.vehicle?.color || ""}
                                onChange={handleEditChange}
                                style={{
                                  border: "1px solid #e9ecef",
                                  fontSize: "11px",
                                }}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <label
                                for="registrationNo"
                                style={{ fontSize: "11px" }}
                              >
                                Registration No
                              </label>
                              <Input
                                type="text"
                                name="registrationNo"
                                id="registrationNo"
                                value={edit?.vehicle?.reg_no || ""}
                                onChange={handleEditChange}
                                style={{
                                  border: "1px solid #e9ecef",
                                  fontSize: "11px",
                                }}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </div>

                      {/* Flight Details */}
                      <div
                        className="p-5 mb-3"
                        style={{ border: "2px solid blue" }}
                      >
                        <h5 style={{ fontSize: "11px", fontWeight: "bold" }}>
                          Flight Details
                        </h5>
                        <Row>
                          <Col md={6}>
                            <FormGroup>
                              <label
                                for="departureTime"
                                style={{ fontSize: "11px" }}
                              >
                                Departure Time
                              </label>
                              <Input
                                type="time"
                                name="departureTime"
                                id="departureTime"
                                value={edit?.departure_time || ""}
                                onChange={handleEditChange}
                                style={{
                                  border: "1px solid #e9ecef",
                                  fontSize: "11px",
                                }}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <label
                                for="arrivalTime"
                                style={{ fontSize: "11px" }}
                              >
                                Arrival Time
                              </label>
                              <Input
                                type="time"
                                name="arrivalTime"
                                id="arrivalTime"
                                value={edit?.arrival_time || ""}
                                onChange={handleEditChange}
                                style={{
                                  border: "1px solid #e9ecef",
                                  fontSize: "11px",
                                }}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={6}>
                            <FormGroup>
                              <label
                                for="departureTerminal"
                                style={{ fontSize: "11px" }}
                              >
                                Departure Terminal
                              </label>
                              <Input
                                type="text"
                                name="departureTerminal"
                                id="departureTerminal"
                                value={edit?.departure_terminal || ""}
                                onChange={handleEditChange}
                                style={{
                                  border: "1px solid #e9ecef",
                                  fontSize: "11px",
                                }}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <label
                                for="departureFlightNo"
                                style={{ fontSize: "11px" }}
                              >
                                Departure Flight No
                              </label>
                              <Input
                                type="text"
                                name="departureFlightNo"
                                id="departureFlightNo"
                                value={edit?.departure_flight_no || ""}
                                onChange={handleEditChange}
                                style={{
                                  border: "1px solid #e9ecef",
                                  fontSize: "11px",
                                }}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={6}>
                            <FormGroup>
                              <label
                                for="arrivalTerminal"
                                style={{ fontSize: "11px" }}
                              >
                                Arrival Terminal
                              </label>
                              <Input
                                type="text"
                                name="arrivalTerminal"
                                id="arrivalTerminal"
                                value={edit?.arrival_terminal || ""}
                                onChange={handleEditChange}
                                style={{
                                  border: "1px solid #e9ecef",
                                  fontSize: "11px",
                                }}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <label
                                for="arrivalFlightNo"
                                style={{ fontSize: "11px" }}
                              >
                                Arrival Flight No
                              </label>
                              <Input
                                type="text"
                                name="arrivalFlightNo"
                                id="arrivalFlightNo"
                                value={edit?.arrival_flight_no || ""}
                                onChange={handleEditChange}
                                style={{
                                  border: "1px solid #e9ecef",
                                  fontSize: "11px",
                                }}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </div>
                    </Form>
                  ))}
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={handleEditSubmit} size="sm">
                  Update
                </Button>
                <Button color="danger" onClick={toggleEditModal} size="sm">
                  Cancel
                </Button>
              </ModalFooter>
            </Modal>

            {/* Extend Modal  */}

            <Modal
              isOpen={isExtendModalOpen}
              toggle={() => setIsExtendModalOpen(!isExtendModalOpen)}
              size="xl"
            >
              <ModalHeader
                toggle={() => setIsExtendModalOpen(!isExtendModalOpen)}
                className="custom-modal-header w-100 text-white"
              >
                <div className="d-flex flex-column w-100">
                  <div
                    className="d-flex justify-content-between"
                    style={{
                      fontSize: "13px",
                      fontWeight: "bold",
                    }}
                  >
                    <div className="text-white">
                      Booking Reference Number: {extendData?.reference_no}
                    </div>
                    <div className="text-white">
                      Company:{" "}
                      {extendData?.bookingDetails?.length
                        ? extendData?.bookingDetails[0]?.company.name
                        : null}
                    </div>
                  </div>
                </div>
              </ModalHeader>
              <ModalBody>
                {extendData?.bookingDetails
                  ?.filter(
                    extend =>
                      extend?.is_current === true || extend?.is_current === 1
                  )
                  ?.map((extend, index) => (
                    <Form>
                      <Row>
                        <Col md={4}>
                          <FormGroup>
                            <label for="departureDate">Departure Date</label>
                            <Input
                              type="date"
                              name="departureDate"
                              id="departureDate"
                              value={extend?.departure_date}
                              onChange={handleExtendChange}
                              style={{
                                border: "1px solid #e9ecef",
                                fontSize: "11px",
                              }}
                            />
                          </FormGroup>
                        </Col>
                        <Col md={4}>
                          <FormGroup>
                            <label for="departureTime">Departure Time</label>
                            <Input
                              type="time"
                              name="departureTime"
                              id="departureTime"
                              value={extend?.departure_time}
                              onChange={handleExtendChange}
                              style={{
                                border: "1px solid #e9ecef",
                                fontSize: "11px",
                              }}
                            />
                          </FormGroup>
                        </Col>
                        <Col md={4}>
                          <FormGroup>
                            <label for="arrivalDate">Arrival Date</label>
                            <Input
                              type="date"
                              name="arrivalDate"
                              id="arrivalDate"
                              value={extend?.arrival_date}
                              onChange={handleExtendChange}
                              style={{
                                border: "1px solid #e9ecef",
                                fontSize: "11px",
                              }}
                            />
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Col md={4}>
                          <FormGroup>
                            <label for="arrivalTime">Arrival Time</label>
                            <Input
                              type="time"
                              name="arrivalTime"
                              id="arrivalTime"
                              value={extend?.arrival_time}
                              onChange={handleExtendChange}
                              style={{
                                border: "1px solid #e9ecef",
                                fontSize: "11px",
                              }}
                            />
                          </FormGroup>
                        </Col>
                        <Col md={4}>
                          <FormGroup>
                            <label for="quoteAmount">Quote Amount</label>
                            <Input
                              type="number"
                              name="quoteAmount"
                              id="quoteAmount"
                              value={extend?.payment?.amount}
                              onChange={handleExtendChange}
                              style={{
                                border: "1px solid #e9ecef",
                                fontSize: "11px",
                              }}
                            />
                          </FormGroup>
                        </Col>
                        <Col md={4}>
                          <FormGroup>
                            <label for="totalAmount">Total Amount</label>
                            <Input
                              type="number"
                              name="totalAmount"
                              id="totalAmount"
                              value={
                                (parseFloat(extend?.payment.amount) || 0) +
                                (parseFloat(
                                  extend?.payment.cancellation_charges
                                ) || 0) +
                                (parseFloat(extend?.payment.sms_charges) || 0) +
                                (parseFloat(extend?.payment.levy_charges) ||
                                  0) +
                                (parseFloat(extend?.payment.valet_charges) ||
                                  0) +
                                (parseFloat(extend?.payment.admin_charges) ||
                                  0) +
                                (parseFloat(extend?.payment.extra_charges) ||
                                  0) -
                                (parseFloat(extend?.payment.discount) || 0)
                              }
                              onChange={handleExtendChange}
                              style={{
                                border: "1px solid #e9ecef",
                                fontSize: "11px",
                              }}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={4}>
                          <FormGroup>
                            <label for="extendedPrice">Extended Price</label>
                            <Input
                              type="number"
                              name="extendedPrice"
                              id="extendedPrice"
                              value={extend?.extendedPrice}
                              onChange={handleExtendChange}
                              style={{
                                border: "1px solid #e9ecef",
                                fontSize: "11px",
                              }}
                            />
                          </FormGroup>
                        </Col>
                        <Col md={4}>
                          <FormGroup>
                            <label for="paymentMethod">Payment Method</label>
                            <Input
                              type="select"
                              name="paymentMethod"
                              id="paymentMethod"
                              value={extend?.paymentMethod}
                              onChange={handleExtendChange}
                              style={{
                                border: "1px solid #e9ecef",
                                fontSize: "11px",
                              }}
                            >
                              <option value="">Select</option>
                              <option value="credit_card">Credit Card</option>
                              <option value="paypal">PayPal</option>
                              <option value="bank_transfer">
                                Bank Transfer
                              </option>
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col md={4}>
                          <FormGroup>
                            <label for="transactionId">Transaction ID</label>
                            <Input
                              type="text"
                              name="transactionId"
                              id="transactionId"
                              value={extend?.payment?.transaction_id}
                              onChange={handleExtendChange}
                              style={{
                                border: "1px solid #e9ecef",
                                fontSize: "11px",
                              }}
                            />
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Col md={3}>
                          <FormGroup>
                            <label for="adminCharges">Admin Charges</label>
                            <Input
                              type="number"
                              name="adminCharges"
                              id="adminCharges"
                              value={extend?.payment?.admin_charges}
                              onChange={handleExtendChange}
                              style={{
                                border: "1px solid #e9ecef",
                                fontSize: "11px",
                              }}
                            />
                          </FormGroup>
                        </Col>
                        <Col md={3}>
                          <FormGroup>
                            <label for="extraAmount">Extra Amount</label>
                            <Input
                              type="number"
                              name="extraAmount"
                              id="extraAmount"
                              value={extend?.payment?.extra_charges}
                              onChange={handleExtendChange}
                              style={{
                                border: "1px solid #e9ecef",
                                fontSize: "11px",
                              }}
                            />
                          </FormGroup>
                        </Col>
                        <Col md={3}>
                          <FormGroup>
                            <label for="levyCharges">Levy Charges</label>
                            <Input
                              type="number"
                              name="levyCharges"
                              id="levyCharges"
                              value={extend?.payment?.levy_charges}
                              onChange={handleExtendChange}
                              style={{
                                border: "1px solid #e9ecef",
                                fontSize: "11px",
                              }}
                            />
                          </FormGroup>
                        </Col>
                        <Col md={3}>
                          <FormGroup>
                            <label for="valetCharges">Valet Charges</label>
                            <Input
                              type="number"
                              name="valetCharges"
                              id="valetCharges"
                              value={extend?.payment?.valet_charges}
                              onChange={handleExtendChange}
                              style={{
                                border: "1px solid #e9ecef",
                                fontSize: "11px",
                              }}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Button color="primary" onClick={handleExtendSubmit}>
                        Extend
                      </Button>
                      <Button
                        color="danger"
                        onClick={() => setIsExtendModalOpen(false)}
                        className="ms-2"
                      >
                        Cancel
                      </Button>

                      <FormGroup>
                        <div className="d-flex justify-content-between p-5">
                          <label
                            style={{
                              fontWeight: "bold",
                            }}
                          >
                            Optional Services
                          </label>
                          <div>
                            <FormGroup check>
                              <label check>
                                <Input
                                  type="checkbox"
                                  name="cancellationCover"
                                  checked={extend?.cancellation_status === 1}
                                  onChange={handleExtendChange}
                                  border="primary"
                                />
                                Cancellation Cover
                              </label>
                            </FormGroup>
                          </div>
                          <div>
                            <FormGroup check>
                              <label check>
                                <Input
                                  type="checkbox"
                                  name="smsCharges"
                                  checked={
                                    extend?.sms_status == "failed"
                                      ? false
                                      : true
                                  }
                                  onChange={handleExtendChange}
                                  style={{
                                    border: "1px solid #e9ecef",
                                  }}
                                />{" "}
                                SMS Charges
                              </label>
                            </FormGroup>
                          </div>
                        </div>
                      </FormGroup>

                      <Row className="d-flex justify-content-between align-items-center">
                        <Col md={4}>
                          <FormGroup>
                            <label for="discountCode">Discount Code</label>
                            <Input
                              type="text"
                              name="discountCode"
                              id="discountCode"
                              value={extend?.payment?.discount_code || ""}
                              onChange={handleExtendChange}
                              style={{
                                border: "1px solid #e9ecef",
                                fontSize: "11px",
                              }}
                            />
                          </FormGroup>
                        </Col>
                        <Col md={4}>
                          <FormGroup>
                            <label for="discountAmount">Discount Amount</label>
                            <Input
                              type="number"
                              name="discountAmount"
                              id="discountAmount"
                              value={extend?.payment?.discount}
                              onChange={handleExtendChange}
                              style={{
                                border: "1px solid #e9ecef",
                                fontSize: "11px",
                              }}
                            />
                          </FormGroup>
                        </Col>
                        <Col md={4}>
                          <Button
                            color="primary"
                            onClick={() => {
                              console.log("Hello")
                            }}
                            size="sm"
                          >
                            Apply
                          </Button>
                        </Col>
                      </Row>

                      <FormGroup>
                        <label for="specialNotes">Special Notes</label>
                        <Input
                          type="textarea"
                          name="specialNotes"
                          id="specialNotes"
                          value={extendData.specialNotes}
                          onChange={handleExtendChange}
                          style={{
                            border: "1px solid #e9ecef",
                            fontSize: "11px",
                          }}
                        />
                      </FormGroup>
                    </Form>
                  ))}
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={handleExtendSubmit}>
                  Submit
                </Button>
              </ModalFooter>
            </Modal>

            {/* Amend Booking  */}

            <AmendBookingModal
              isOpen={amendBookingModal}
              toggle={toggleAmendBookingModal}
            />

            {/* shift modal  */}

            <Modal
              isOpen={isShiftModalOpen}
              toggle={toggleShiftModal}
              size="xl"
            >
              <div>
                <ModalHeader
                  toggle={toggleShiftModal}
                  className="custom-modal-header w-100 text-white"
                >
                  <div className="d-flex flex-column w-100">
                    <div
                      className="d-flex justify-content-between"
                      style={{
                        fontSize: "13px",
                        fontWeight: "bold",
                      }}
                    >
                      <div className="text-white">
                        Booking Reference Number: CPD-243433
                      </div>
                      <div className="text-white">
                        COMPANY - Smart Heathrow Parking
                      </div>
                    </div>
                  </div>
                </ModalHeader>
                <ModalBody>
                  <Form>
                    <FormGroup>
                      <label
                        for="company"
                        style={{
                          fontSize: "11px",
                        }}
                      >
                        Companies
                      </label>
                      <Input
                        type="select"
                        name="company"
                        id="company"
                        style={{
                          border: "1px solid #e9ecef",
                          fontSize: "11px",
                        }}
                      >
                        <option value="meet_and_greet">Meet and Greet</option>
                        <option value="park_and_ride">Park and Ride</option>
                        <option value="ace_parking">Ace Parking</option>
                      </Input>
                    </FormGroup>
                  </Form>
                </ModalBody>
                <ModalFooter>
                  <Button color="primary" size="sm" onClick={toggleShiftModal}>
                    Shift Booking
                  </Button>
                  <Button color="danger" size="sm" onClick={toggleShiftModal}>
                    Cancel
                  </Button>
                </ModalFooter>
              </div>
            </Modal>

            {/* Incomplete Modal  */}

            {incompleteModalOpen && (
              <IncompleteBookingForm
                isOpen={incompleteModalOpen}
                toggle={() => setIncompleteModalOpen(!incompleteModalOpen)}
                setIncompleteModalOpen={setIncompleteModalOpen}
                handleFetchBookingDetails={handleFetchBookingDetails}
              />
            )}

            {/* Cancel Modal  */}

            <Modal
              isOpen={isCancelModalOpen}
              toggle={toggleCancelModal}
              size="xl"
            >
              <ModalHeader
                toggle={toggleCancelModal}
                className="custom-modal-header w-100 text-white"
              >
                <div className="d-flex flex-column w-100">
                  <div
                    className="d-flex justify-content-between"
                    style={{
                      fontSize: "13px",
                      fontWeight: "bold",
                    }}
                  >
                    <div className="text-white">
                      Booking Reference Number: CPD-243433
                    </div>
                    <div className="text-white">
                      COMPANY - Smart Heathrow Parking
                    </div>
                    <div className="text-white">Status - Completed</div>
                  </div>
                </div>
              </ModalHeader>
              <ModalBody>
                <Form>
                  <FormGroup>
                    <label for="refundAmount">Refund Amount</label>
                    <Input
                      type="number"
                      name="refundAmount"
                      id="refundAmount"
                      value={cancelData.refundAmount}
                      onChange={e =>
                        setCancelData({
                          ...cancelData,
                          refundAmount: e.target.value,
                        })
                      }
                      style={{ border: "1px solid #e9ecef", fontSize: "11px" }}
                    />
                  </FormGroup>
                  <FormGroup>
                    <label for="specialNotes">Special Notes</label>
                    <Input
                      type="textarea"
                      name="specialNotes"
                      id="specialNotes"
                      value={cancelData.specialNotes}
                      onChange={e =>
                        setCancelData({
                          ...cancelData,
                          specialNotes: e.target.value,
                        })
                      }
                      style={{ border: "1px solid #e9ecef", fontSize: "11px" }}
                    />
                  </FormGroup>
                </Form>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="primary"
                  size="sm"
                  onClick={() => {
                    toggleCancelModal()
                  }}
                >
                  Submit
                </Button>
                <Button color="danger" size="sm" onClick={toggleCancelModal}>
                  Cancel
                </Button>
              </ModalFooter>
            </Modal>

            {/* Re Active Modal  */}

            <Modal
              isOpen={reActiveModalOpen}
              toggle={toggleReactiveModal}
              size="xl"
            >
              <ModalHeader
                toggle={toggleCancelModal}
                className="custom-modal-header w-100 text-white"
              >
                <div className="d-flex flex-column w-100">
                  <div
                    className="d-flex justify-content-between"
                    style={{
                      fontSize: "13px",
                      fontWeight: "bold",
                    }}
                  >
                    <div className="text-white">
                      Booking Reference Number: CPD-243433
                    </div>
                    <div className="text-white">
                      COMPANY - Smart Heathrow Parking
                    </div>
                    <div className="text-white">Status - Completed</div>
                  </div>
                </div>
              </ModalHeader>
              <ModalBody>
                <Form>
                  <FormGroup>
                    <label for="transactionId">Transaction ID</label>
                    <Input
                      type="text"
                      name="transactionId"
                      id="transactionId"
                      value={reActiveData.transactionId}
                      onChange={e =>
                        setReActiveData({
                          ...reActiveData,
                          transactionId: e.target.value,
                        })
                      }
                      style={{ border: "1px solid #e9ecef", fontSize: "11px" }}
                    />
                  </FormGroup>
                  <FormGroup>
                    <label for="specialNotes">Special Notes</label>
                    <Input
                      type="textarea"
                      name="specialNotes"
                      id="specialNotes"
                      value={cancelData.specialNotes}
                      onChange={e =>
                        setCancelData({
                          ...cancelData,
                          specialNotes: e.target.value,
                        })
                      }
                      style={{ border: "1px solid #e9ecef", fontSize: "11px" }}
                    />
                  </FormGroup>
                </Form>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="primary"
                  size="sm"
                  onClick={() => {
                    toggleReactiveModal()
                  }}
                >
                  Reactivate Booking
                </Button>
                <Button color="danger" size="sm" onClick={toggleReactiveModal}>
                  Cancel
                </Button>
              </ModalFooter>
            </Modal>

            {/* Delete Modal  */}

            <Modal
              isOpen={isDeleteModalOpen}
              toggle={() => setIsDeleteModalOpen(false)}
            >
              <ModalHeader toggle={() => setIsDeleteModalOpen(false)}>
                <div className="d-flex align-items-center">
                  <h5>Deleting!</h5>
                </div>
              </ModalHeader>
              <ModalBody>
                {isDeleting ? ( // Show loader if deleting
                  <div className="d-flex justify-content-center">
                    <Spinner color="primary" />{" "}
                    {/* You can use any loader component */}
                    <span className="ms-2">Deleting...</span>
                  </div>
                ) : (
                  <>
                    <p>Are you sure? </p>
                    <p>Resource will be deleted from the system.</p>
                  </>
                )}
              </ModalBody>
              <ModalFooter>
                <Button
                  color="danger"
                  onClick={handleDelete}
                  disabled={isDeleting}
                >
                  Delete
                </Button>
                <Button
                  color="secondary"
                  onClick={() => setIsDeleteModalOpen(false)}
                  disabled={isDeleting}
                >
                  Cancel
                </Button>
              </ModalFooter>
            </Modal>
          </tbody>
        </Table>
      </div>
      <div style={{ margin: "20px 0px" }} className="border-secondary">
        {!loading && (
          <>
            <p
              style={{
                fontWeight: "bold",
                marginTop: "30px",
                fontSize: "16px",
                marginLeft: "40px",
              }}
            >
              Total Bookings: {totalBookings}
            </p>
            {renderPagination()}
          </>
        )}
      </div>
    </div>
  )
}

export default AllBookings
